import { Flex, Title, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";

type ColumnCardProps = {
  text: string;
  index: number;
};

export const ColumnCard: FC<ColumnCardProps> = ({ text, index }) => {
  return (
    <Flex
      bg="surface-primary-grad-subtle"
      border={{ radius: "16px" }}
      align="center"
      flexDirection="row"
      justify="flex-start"
      gap={24}
      height="100%"
      d={{ gap: 32, maxWidth: 400 }}
      p={{ pl: 32 }}
      minWidth={312}
      maxWidth={400}
      width="100%"
    >
      <Typography
        as="span"
        fontWeight="desktop.bold"
        bg="text-accent-grad"
        maxWidth={128}
        className="!text-[96px] !leading-[134px]  bg-clip-text text-transparent"
      >
        {index < 10 ? `0${index}` : index}
      </Typography>
      <Flex
        justify="center"
        flexDirection="column"
        p={{ py: 12, pr: 12 }}
        height="max-content"
        className="flex-grow"
      >
        <Title
          as="h4"
          size="small"
          fontWeight="mobile.bold"
          md={{
            fontWeight: "desktop.bold",
            lineHeight: "title.desktop.medium",
            p: { pb: 8 },
          }}
          d={{ lineHeight: "title.desktop.small" }}
          p={{ pb: 8 }}
        >
          {text.split(" ")[0]}
        </Title>
        <Typography size="medium" d={{ size: "large" }} height="fit-content">
          {text.split(" ").slice(1).join(" ")}
        </Typography>
      </Flex>
    </Flex>
  );
};
